import { useMemo } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  CUSTOMER_LOCK_DURATION_MAX,
  CUSTOMER_LOCK_DURATION_MIN,
} from 'src/config/form-validation-rules';
import { useFormValidation } from 'src/shared/form/use-form-validation';
import { DurationModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/shared/src/user-service/models/lock-user.model';

export function useCustomerFormValidation(): Record<
  keyof DurationModel,
  RegisterOptions
> {
  const { t } = useTranslation();

  const customerLockTranslations: Record<keyof DurationModel, string> = t(
    'model.customer-lock',
    {
      returnObjects: true,
    },
  );

  const formValidationRules = useFormValidation();

  return useMemo(
    () => ({
      duration: {
        ...formValidationRules.max({
          field: customerLockTranslations.duration,
          value: CUSTOMER_LOCK_DURATION_MAX,
        }),

        ...formValidationRules.min({
          field: customerLockTranslations.duration,
          value: CUSTOMER_LOCK_DURATION_MIN,
        }),
      },
    }),
    [formValidationRules, customerLockTranslations],
  );
}
